import React from 'react';
import {
    Card,
    Stack,
    Skeleton,
    Divider,
} from '@mui/material';

const UserCardSkeleton: React.FC = () => {
    return (
        <Card
            elevation={3}
            sx={{
                borderRadius: 1,
                backgroundColor: '#fff',
                p: 2,
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
            }}
        >
            <Stack spacing={1}>
                {/* Header with checkbox and status */}
                <Stack direction='row' justifyContent='space-between' alignItems='center'>
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton 
                        variant="rounded" 
                        width={80} 
                        height={30} 
                        sx={{ borderRadius: '15px' }}
                    />
                </Stack>

                <Divider />

                {/* Username and Edit link */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Skeleton variant="text" width={120} height={20} />
                    <Skeleton variant="text" width={40} height={20} />
                </div>

                {/* Roles */}
                <Stack spacing={0.5}>
                    <Skeleton 
                        variant="rounded" 
                        width={140} 
                        height={24} 
                        sx={{ borderRadius: '13px' }}
                    />
                    <Skeleton 
                        variant="rounded" 
                        width={160} 
                        height={24} 
                        sx={{ borderRadius: '13px' }}
                    />
                </Stack>

                {/* Last Changed and Last Access */}
                <Skeleton variant="text" width={150} height={16} />
                <Skeleton variant="text" width={140} height={16} />
            </Stack>
        </Card>
    );
};

export default UserCardSkeleton; 